import { render, staticRenderFns } from "./SignCard.vue?vue&type=template&id=48430a2d&"
import script from "./SignCard.vue?vue&type=script&lang=js&"
export * from "./SignCard.vue?vue&type=script&lang=js&"
import style0 from "./SignCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48430a2d')) {
      api.createRecord('48430a2d', component.options)
    } else {
      api.reload('48430a2d', component.options)
    }
    module.hot.accept("./SignCard.vue?vue&type=template&id=48430a2d&", function () {
      api.rerender('48430a2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/febos/SignCard.vue"
export default component.exports